import { useQuery } from "@tanstack/react-query";
import { axios } from "./axios";
import { useAuth } from "../context/AuthContext";
import { env } from "../utils/env";

export type ProfileStatus = {
  id: number;
  label: string;
  status: string;
};

const fetchProfileStatusList = (authHeader: string) => () =>
  axios.get<ProfileStatus[]>(
    `${env.verifyServiceUrl}common/profile_status_list/`,
    {
      headers: {
        Authorization: authHeader,
      },
    }
  );

export const useProfileStatusList = () => {
  const { authHeader } = useAuth();

  return useQuery(["profileStatusList"], fetchProfileStatusList(authHeader), {
    retry: false,
  });
};
